import React from 'react'
import Navbar from '../Header/Navbar'
import PartTimeHero from './PartTimeVirtualCFO/PartTimeHero'
import PartTimeSection from './PartTimeVirtualCFO/PartTimeSection'
import PartTimeTrust from './PartTimeVirtualCFO/PartTimeTrust'
import Footer from '../Footer/Footer'

function PartTimeVirtualCFO() {
    return (
        <div>
            <PartTimeHero/>
            <PartTimeSection/>
            <PartTimeTrust/>
            <Footer/>
        </div>
    )
}

export default PartTimeVirtualCFO
